export const getProgresses = state => state

export const getProgressForServer = (state, server) => state[server]



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/progress/selectors.js